import TablaDetalle from "#common/tablaDetalle/TablaDetalle"
import CompetenceTable from "#competence/components/competence/CompetenceTable"
import CompetenceInfo from "#competence/components/competence/info/CompetenceInfo"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box, Skeleton } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useNavigate } from "react-router-dom"
import { competenceGet } from "../services/Api"
export default function Competencia() {
	ChangeTitle("competencia")
	const { reload } = UseContextsCompetence()
	const navigate = useNavigate()
	const {
		data: competencia,
		error,
		loading,
	} = useApi(competenceGet, { autoFetch: true, reload })

	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"90vh"} />
	if (error) return <ErrorResponse />

	return (
		<Box>
			<TablaDetalle
				title="competencia"
				nameParam="id"
				ruta="/competencia"
				tabla={
					<CompetenceTable
						data={competencia?.data || []}
						onClick={(competence) => {
							navigate(`${competence?.id}`)
						}}
					/>
				}
				Detalle={CompetenceInfo}
			/>
		</Box>
	)
}
